import { CSVLink } from "react-csv";
import React from "react";
import { Button } from "react-bootstrap";

const CSVExport = (props) => {
  return (
    <CSVLink
      data={props.rowData}
      headers={props.header}
      filename={props.filename}
      style={
        props.disableExport
          ? { textDecoration: "none", pointerEvents: "none" }
          : { textDecoration: "none" }
      }
      className={props.classSelected}
    >
      <Button size="sm" variant="outline-dark">
        {props.label}
      </Button>
    </CSVLink>
  );
};
export default CSVExport;
